$(".upload .video__thumb .thumb").imagepicker();
